var map = {
	"./category-arts-design.svg": 43780,
	"./category-biography-memoir.svg": 5470,
	"./category-business.svg": 2233,
	"./category-career-success.svg": 44489,
	"./category-communication.svg": 13800,
	"./category-economics.svg": 60883,
	"./category-education.svg": 25770,
	"./category-entertainment.svg": 61199,
	"./category-entrepreneurship.svg": 32849,
	"./category-fiction.svg": 54315,
	"./category-food.svg": 95539,
	"./category-health.svg": 84351,
	"./category-history.svg": 55395,
	"./category-law.svg": 82417,
	"./category-lifestyle.svg": 2348,
	"./category-management-leadership.svg": 42696,
	"./category-marketing.svg": 94466,
	"./category-media.svg": 22979,
	"./category-money-finance.svg": 14308,
	"./category-motivation.svg": 23840,
	"./category-parenting.svg": 38559,
	"./category-philosophy.svg": 61334,
	"./category-politics.svg": 37222,
	"./category-productivity.svg": 40938,
	"./category-psychology.svg": 28191,
	"./category-relationships.svg": 90721,
	"./category-sales.svg": 1008,
	"./category-science.svg": 29905,
	"./category-self-improvement.svg": 70819,
	"./category-society-culture.svg": 9740,
	"./category-spirituality.svg": 54970,
	"./category-sports.svg": 85400,
	"./category-technology.svg": 7134
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 68244;